import type { PeriodGroupWithMinutes } from './period-group-with-minutes';

/**
 * Sets start and end for a period group corresponding to first start and last end of periods
 */
export function finalizeGroup(group: PeriodGroupWithMinutes) {
  let startMinutes = 1000000;
  let start = '';
  let endMinutes = 0;
  let end = '';
  group.periods.forEach(function (period) {
    if (period.startMinutes < startMinutes) {
      startMinutes = period.startMinutes;
      start = period.start;
    }
    if (period.endMinutes > endMinutes) {
      endMinutes = period.endMinutes;
      end = period.end;
    }
  });
  group.start = start;
  group.startMinutes = startMinutes;
  group.end = end;
  group.endMinutes = endMinutes;
  return group;
}
